import { useState } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import Auth from './auth';
import Content from './content';
import Header from './header';
import Footer from './footer';
import Logout from './logout';
import { AlertContextWrapper } from 'hooks/useAlertWithTimeout';
import styles from './index.module.scss';

function Shell() {
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <AlertContextWrapper>
      <Switch>
        <Route path={['/login', '/register', '/forgot-password']}>
          <Auth />
        </Route>
        <Route>
          <div
            className={classnames(styles.shell, {
              [styles.gridBackground]: ['/fileList', '/manage'].some(e =>
                pathname.startsWith(e)
              ),
              [styles.noBackground]: ['/', '/help'].includes(pathname)
            })}>
            <Header onSelectLogout={() => setIsLogoutOpen(true)} />
            <div className={styles.wrapper}>
              <Content className={styles.content} />
              <Footer />
            </div>
          </div>
        </Route>
      </Switch>
      <Logout isOpen={isLogoutOpen} onClose={() => setIsLogoutOpen(false)} />
    </AlertContextWrapper>
  );
}

export default Shell;
